import type { ExtractKeyUnion } from "@vTypes/util-type.ts";
import { SubTab, SubTabItem } from "@/layouts/SubTab";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useIsGroupNurse, useLoginUser } from "@/hooks/useAuth";
import { useGroupSelection } from "@/hooks/useGroupSelection";

const ROSTER_TABS = [
  {
    name: "ALL",
    displayName: "전체 근무표",
    to: "/roster_view",
    end: true,
  },
  {
    name: "MY",
    displayName: "내 근무표",
    to: "/roster_view/my",
    end: true,
  },
] as const;

export type UnionRosterTabs = ExtractKeyUnion<typeof ROSTER_TABS, "name">;

export function RosterTabs() {
  const loginUser = useLoginUser();
  const isGroupNurse = useIsGroupNurse();
  const { selectedGroupId } = useGroupSelection();

  const homeGroupId = (loginUser?.original_group_id ?? loginUser?.group_id ?? "").trim();
  const activeGroupId = (selectedGroupId ?? "").trim();
  const disableMyRosterTab =
    isGroupNurse &&
    homeGroupId !== "" &&
    activeGroupId !== "" &&
    homeGroupId !== activeGroupId;

  return (
    <SubTab aria-label="근무표 탭">
      {ROSTER_TABS.map((tab, index) => {
        const disabled = tab.name === "MY" && disableMyRosterTab;
        const item = (
          <SubTabItem
            value={index}
            label={tab.displayName}
            to={tab.to}
            end={tab.end}
            preserveSearch
            disabled={disabled}
          />
        );

        if (!disabled) {
          return <span key={tab.name}>{item}</span>;
        }

        return (
          <Tooltip key={tab.name}>
            <TooltipTrigger asChild>
              <span className="inline-flex">{item}</span>
            </TooltipTrigger>
            <TooltipContent side="bottom">
              소속 병동에서만 내 근무표를 볼 수 있습니다.
            </TooltipContent>
          </Tooltip>
        );
      })}
    </SubTab>
  );
}
